import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { noop } from '../../utils';
import UpdateTextModal from '../UpdateTextModal';

const ChallengeHowToWin = ({
    isOpen,
    setOpen,
    text,
    onClose,
    onCancel,
    onConfirm,
}) => {
    const { t } = useTranslation();

    return (
        <UpdateTextModal
            isOpen={isOpen}
            setOpen={setOpen}
            title={t('challenge.howToWinFieldTitle')}
            label={t('challenge.info.howToWin')}
            text={text}
            onClose={onClose}
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    );
};

ChallengeHowToWin.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func.isRequired,
};

ChallengeHowToWin.defaultProps = {
    onClose: noop,
    onCancel: noop,
};

export default ChallengeHowToWin;
